// Options and their corresponding file name
  const opt_dict = {
    "White": "white.png",
    "Black": "black.png",
    "Hydrangea-Blue": "hydrangea-blue.png",
    "Turquoise": "turqouise.png",
    "Racing-Green": "racing-green.png",
    "Metallic-Gold": "metallic-gold.png",
    "Matcha-Green": "matcha-green.png",
    "Pink": "pink.png",
    "White---The-Tower-200": "white.png",
    "Black---The-Tower-200": "black.png",
    "Matcha-Green---The-Tower-200": "matcha-green.png",
    "White---The-Tower-300": "white.png",
    "Black---The-Tower-300": "black.png",
    "Hydrangea-Blue---The-Tower-300": "hydrangea-blue.png",
    "Turquoise---The-Tower-300": "turqouise.png",
    "Racing-Green---The-Tower-300": "racing-green.png",
    "Matcha-Green---The-Tower-300": "matcha-green.png",
    "Bumblebee---The-Tower-300": "bumblebee.png",
    "Bubble-Pink---The-Tower-300": "pink.png",
    "Limestone---The-Tower-300": "limestone.png",
    "The-Wilier-Edition---The-Tower-300": "wilier-edition.png",
    "White---The-Tower-600": "white.png",
    "Black---The-Tower-600": "black.png",
    "Hydrangea-Blue---The-Tower-600": "hydrangea-blue.png",
    "Matcha-Green---The-Tower-600": "matcha-green.png",
    "Bubble-Pink---The-Tower-600": "pink.png",
    "Racing-Green---The-Tower-600": "racing-green.png",
    "Future-Dusk---The-Tower-600": "future-dusk.png",
    "Gravel-Sand---The-Tower-600": "gravel-sand.png",
    "Bumblebee---The-Tower-600": "bumblebee.png",
    "White---Divider-350": "white.png",
    "White---View-350": "white.png",
    "View-270---Black": "black.png",
    "View-270---White": "white.png",
    "View-270---Hydrangea-Blue": "hydrangea-blue.png",
    "View-270---Matcha-Green": "matcha-green.png",
    "View-270-SP-Edition---Black": "black-sp.png",
    "View-270-SP-Edition---White": "white-sp.png",
    "View-270-WS---Black": "black-walnut.png",
    "View-270-WS---White": "white-birch.png",
    "View-380-WS---Black": "black-walnut.png",
    "View-380-WS---White": "white-birch.png",
    "View-380-XL-WS---Black": "black-walnut.png",
    "View-380-XL-WS---White": "white-birch.png",
    "View-380-XL-WS---Matcha-Green": "matcha-green-walnut.png",
    "TR300-WS---Black": "black-walnut.png",
    "View-380---Black": "black.png",
    "View-380---White": "white.png",
    "View-380---Hydrangea-Blue": "hydrangea-blue.png",
    "View-380---Matcha-Green": "matcha-green.png",
    "View-380---Bubble-Pink": "pink.png",
    "View-380-XL---Black": "black.png",
    "View-380-XL---White": "white.png",
    "View-390---Black": "black.png",
    "View-390---White": "white.png",
    "View-390---Future-Dusk": "future-dusk.png",
    "View-390---Butter-Caramel": "butter-caramel.png",
    "View-390---Transformative-Teal": "Transformative-Teal.png",
    "TR100---Blackmini-ITX": "black.png",
    "TR100---Snowmini-ITX": "white.png",
    "TR100---Hydrangea-Bluemini-ITX": "hydrangea-blue.png",
    "TR100---Matcha-Greenmini-ITX": "matcha-green.png",
    "TR100---Bubble-Pinkmini-ITX": "pink.png",
    "TR100---Mint-Strawberrymini-ITX": "mint-strawberry.png",
    "TR100---Future-Duskmini-ITX": "future-dusk.png",
    "TR100---Gravel-Sandmini-ITX": "gravel-sand.png",
    "TR100---WS-Matcha-Greenmini-ITX--Wood-Panel": "matcha-green-walnut.png",
    "CT-ARGB-PC-Cooling-Fan": "COOLINGFAN-CT_ARGB_pc_cooling_fan.png",
    "SWAFAN-EX-ARGB-PC-Cooling-Fan---8PCS": "COOLINGFAN-SWAFAN_EX_ARGB_pc_cooling_fan.png",
    "SWAFAN-EX-ARGB-PC-Cooling-Fan---11PCS": "COOLINGFAN-SWAFAN_EX_ARGB_pc_cooling_fan.png",
    "AMD-Ryzen-5-5600X": "PROCESSOR-AMD5.png",
    "AMD-Ryzen-7-5700": "PROCESSOR-AMD7.png",
    "AMD-Ryzen-7-5800X": "PROCESSOR-AMD7.png",
    "AMD-Ryzen-7-5800X3D": "PROCESSOR-AMD7.png",
    "AMD-Ryzen-7-7700X": "PROCESSOR-AMD7.png",
    "AMD-Ryzen-7-7800X3D": "PROCESSOR-AMD7.png",
    "AMD-Ryzen-7-9700X": "PROCESSOR-AMD7.png",
    "AMD-Ryzen-7-9800X3D": "PROCESSOR-AMD-Ryzen7_9000_series.png",
    "AMD-Ryzen-7-9800X3D-+-ASUS-TUF-B850M-P-WIFI": "PROCESSOR-AMD-Ryzen7_9000_series.png",
    "AMD-Ryzen-7-9850X3D": "PROCESSOR-AMD-Ryzen7_9000_series.png",
    "AMD-Ryzen-7-9850X3D-+-ASUS-TUF-B850M-P-WIFI": "PROCESSOR-AMD-Ryzen7_9000_series.png",
    "AMD-Ryzen-9-5900X": "PROCESSOR-AMD9.png",
    "AMD-Ryzen-9-5950X": "PROCESSOR-AMD9.png",
    "AMD-Ryzen-9-9950X": "PROCESSOR-AMD-Ryzen9_9000_series.png",
    "AMD-Ryzen-9-9900X3D": "PROCESSOR-AMD-Ryzen9_9000_series.png",
    "AMD-Ryzen-9-9900X3D-+-ASUS-TUF-B850M-P-WIFI": "PROCESSOR-AMD-Ryzen9_9000_series.png",
    "AMD-Ryzen-9-9950X3D": "PROCESSOR-AMD-Ryzen9_9000_series.png",
    "AMD-Ryzen-9-9950X3D-+-ASUS-TUF-B850M-P-WIFI": "PROCESSOR-AMD-Ryzen9_9000_series.png",
    "Intel-Core-i5-13400F": "PROCESSOR-Inteli5-13th.png",
    "Intel-Core-i5-12600KF": "PROCESSOR-Inteli5-12th.png",
    "Intel-Core-i5-13600KF": "PROCESSOR-Inteli5-13th.png",
    "Intel-Core-i5-14400F": "PROCESSOR-Inteli5-14th.png",
    "Intel-Core-i5-14600K": "PROCESSOR-Inteli5-14th.png",
    "Intel-Core-i5-14600KF": "PROCESSOR-Inteli5-14th.png",
    "Intel-Core-i7-11700K": "PROCESSOR-Inteli7-11th.png",
    "Intel-Core-i7-12700KF": "PROCESSOR-Inteli7-12th.png",
    "Intel-Core-i7-12700F": "PROCESSOR-Inteli7-12th.png",
    "Intel-Core-i7-13700KF": "PROCESSOR-Inteli7-13th.png",
    "Intel-Core-i7-13700K": "PROCESSOR-Inteli7-13th.png",
    "Intel-Core-i7-13700F": "PROCESSOR-Inteli7-13th.png",
    "Intel-Core-i7-14700KF": "PROCESSOR-Inteli7-14th.png",
    "Intel-Core-i7-14700F": "PROCESSOR-Inteli7-14th.png",
    "Intel-Core-i9-12900KF": "PROCESSOR-Inteli9-12th.png",
    "Intel-Core-i9-12900K": "PROCESSOR-Inteli9-12th.png",
    "Intel-Core-i9-13900KF": "PROCESSOR-Inteli9-13th.png",
    "Intel-Core-i9-13900K": "PROCESSOR-Inteli9-13th.png",
    "Intel-Core-i9-14900KF": "PROCESSOR-Inteli9-14th.png",
    "Intel-Core-i9-14900KS": "PROCESSOR-Inteli9-14th.png",
    "Intel-Core-Ultra-5-245KF": "PROCESSOR-Intel-core-ultra5.png",
    "Intel-Core-Ultra-7-265KF": "PROCESSOR-Intel-core-ultra7.png",
    "Intel-Core-Ultra-9-285K": "PROCESSOR-Intel-core-ultra9.png",
    "Intel-Core-Ultra-5-250KF-Plus": "PROCESSOR-Intel-core-ultra5.png",
    "Intel-Core-Ultra-5-250K-Plus": "PROCESSOR-Intel-core-ultra5.png",
    "Intel-Core-Ultra-7-270K-Plus": "PROCESSOR-Intel-core-ultra7.png",
    "AMD-B550-Chipset---DDR4": "MOTHERBOARD-AMD_B550_Chipset.png",
    "ASUS-PRIME-B550-Chipset---DDR4": "MOTHERBOARD-AMD_B550_Chipset.png",
    "AMD-X670-Chipset---DDR5": "MOTHERBOARD-AMD_X670_Chipset.png",
    "Intel-Z690-Chipset---DDR4": "MOTHERBOARD-Intel_Z690_Chipset.png",
    "Intel-Z790-Chipset---DDR5": "MOTHERBOARD-Intel_Z790_Chipset.png",
    "Intel-Z890-Chipset---DDR5": "MOTHERBOARD-Intel_Z890_Chipset.png",
    "ASUS-PRIME-Intel-Z790-P-Chipset---DDR5": "MOTHERBOARD-ASUS_PRIME_Z790-P.png",
    "AMD-X870-Chipset---DDR5-White": "MOTHERBOARD-AMD_X870_Chipset.png",
    "ASRock-X870E-Nova-WiFi---DDR5": "MOTHERBOARD-ASROCK_X870E_Nova.png",
    "ASUS-PRIME-AMD-X870-Chipset---DDR5": "MOTHERBOARD-ASUS_PRIME_X870-P.png",
    "ASUS-ROG-Strix-X870-A-Gaming-WiFi-White": "MOTHERBOARD-ASUS_ROG_Strix_X870-A.png",
    "ASRock-PHANTOM-GAMING-B850I-Lightning-WiFi": "MOTHERBOARD-ASROCK_PhantomGaming_B850I.png",
    "ASRock-PHANTOM-GAMING-B860I-Lightning-WiFi": "MOTHERBOARD-ASROCK_PhantomGaming_B860I.png",
    "Intel-Arc-B580-Steel-Legend-12GB-OC-3X---White": "GRAPHICSCARD-ASROCK_Intel_Arc_B580.png",
    "GeForce-RTX-3050": "GRAPHICSCARD-RTX_3050.png",
    "GeForce-RTX-3060": "GRAPHICSCARD-RTX_3060.png",
    "GeForce-RTX-3060-Ti": "GRAPHICSCARD-RTX_3060_Ti.png",
    "GeForce-RTX-3070": "GRAPHICSCARD-RTX_3070.png",
    "GeForce-RTX-3070-Ti": "GRAPHICSCARD-RTX_3070_Ti.png",
    "GeForce-RTX-3080": "GRAPHICSCARD-RTX_3080.png",
    "GeForce-RTX-4060": "GRAPHICSCARD-RTX_4060.png",
    "GeForce-RTX-4060-Ti": "GRAPHICSCARD-RTX_4060_Ti.png",
    "GeForce-RTX-4060-Ti-White-only": "GRAPHICSCARD-RTX_4060_Ti.png",
    "GeForce-RTX-4070-Super": "GRAPHICSCARD-RTX_4070_Super.png",
    "GeForce-RTX-4070-Super-White-only": "GRAPHICSCARD-RTX_4070_Super.png",
    "GeForce-RTX-4070-Ti-Super": "GRAPHICSCARD-RTX_4070_Ti_Super.png",
    "GeForce-RTX-4070-Ti-Super-White-only": "GRAPHICSCARD-RTX_4070_Ti_Super.png",
    "GeForce-RTX-4080-Super": "GRAPHICSCARD-RTX_4080_Super.png",
    "GeForce-RTX-4070": "GRAPHICSCARD-RTX_4070.png",
    "GeForce-RTX-4070-Ti": "GRAPHICSCARD-RTX_4070_Ti.png",
    "GeForce-RTX-4080": "GRAPHICSCARD-RTX_4080.png",
    "GeForce-RTX-4090": "GRAPHICSCARD-RTX_4090.png",
    "GeForce-RTX-5060": "GRAPHICSCARD-RTX_5060.png",
    "GeForce-RTX-5060-Ti-8GB": "GRAPHICSCARD-RTX_5060_Ti.png",
    "GeForce-RTX-5070": "GRAPHICSCARD-RTX_5070.png",
    "GeForce-RTX-5070-Ti": "GRAPHICSCARD-RTX_5070_Ti.png",
    "GeForce-RTX-5080---May-require-GPU-installation": "GRAPHICSCARD-RTX_5080.png",
    "GeForce-RTX-5090---GPU-installation-is-required": "GRAPHICSCARD-RTX_5090.png",
    "Radeon-RX-9070-XT-16GB": "GRAPHICSCARD-RX_9070_XT.png",
    "ASUS-TUF-Gaming-GeForce-RTX-4080-Super": "GRAPHICSCARD-TUF_GAMING_RTX_4080.png",
    "ASUS-TUF-Gaming-GeForce-RTX-4090-OC": "GRAPHICSCARD-TUF_GAMING_RTX_4090_OC.png",
    "ASUS-ROG-Strix-GeForce-RTX-4090-OC": "GRAPHICSCARD-ROG_Strix_RTX_4090_OC.png",
    "MSI-GeForce-RTX-4080-16GB-GAMING-X-TRIO-WHITE-EDITION": "GRAPHICSCARD_MSI_GeforceRTX4080_WHITE.png",
    "ASUS-ROG-Strix-GeForce-RTX-4090-OC-White": "GRAPHICSCARD_ASUS_GeforceRTX4090_WHITE.png",
    "ASUS-ROG-Astral-GeForce-RTX-5080-16GB-GDDR7-OC---May-require-GPU-installation": "GRAPHICSCARD_ASUS_GeForce_RTX5080OC.png",
    "ASUS-ROG-Astral-GeForce-RTX-5090-32GB-GDDR7-OC----GPU-installation-is-required": "GRAPHICSCARD_ASUS_GeForce_RTX5090OC.png",
    "600W-Power-Supply-80-Plus-Gold": "POWER_600w.png",
    "750W-Power-Supply-80-Plus-Gold": "POWER_750w.png",
    "850W-Power-Supply-80-Plus-Gold": "POWER_850w.png",
    "1000W-Power-Supply-80-Plus-Gold": "POWER_1000w.png",
    "1200W-Power-Supply-80-Plus-Gold": "POWER_1200w.png",
    "850W-Power-Supply-80-Plus-Gold-ATX-30": "POWER_850w_ATX30.png",
    "1000W-Power-Supply-80-Plus-Gold-ATX-30": "POWER_1000w_ATX30.png",
    "1200W-Power-Supply-80-Plus-Gold-ATX-30": "POWER_1200w_ATX30.png",
    "1350W-Power-Supply-80-Plus-Gold-ATX-30": "POWER_1350w_ATX30.png",
    "SFX-850W-Power-Supply-80-Plus-Platinum": "POWER_850W_SFX.png",
    "SFX-1000W-Power-Supply-80-Plus-Platinum": "POWER_1000W_SFX.png",
    "RGB-DDR4-3600MHz-16GB-2x8GB": "MEMORY-ToughramRGB_16gb.png",
    "RGB-DDR4-3600MHz-32GB-4x8GB": "MEMORY-ToughramRGB_32gb.png",
    "RGB-DDR4-3600MHz-64GB": "MEMORY-ToughramRGB_64gb.png",
    "Kingston-FURY-Beast-RGB-DDR5-5600MTs-16GB": "MEMORY-KingstonRGB_16gb.png",
    "Kingston-FURY-Beast-RGB-DDR5-5600MTs-32GB": "MEMORY-KingstonRGB_32gb.png",
    "Kingston-FURY-Beast-DDR5-5200Mhz-64GB-4x16GB": "MEMORY-KingstonRGB_64gb.png",
    "Kingston-FURY-Beast-DDR5-5200Mhz-32GB": "MEMORY-Kingston_32gb.png",
    "Kingston-FURY-Beast-DDR5-5200Mhz-16GB": "MEMORY-Kingston_16gb.png",
    "OLOY-Blade-Performance-RGB-DDR5-4800MHz-32GB": "MEMORY-OLOYBlade_32gb.png",
    "RGB-DDR5-5600MTs-32GB-2x16GB": "MEMORY-Toughram_XG_RGB_32gb.png",
    "RGB-DDR5-5600MTs-64GB-4x16GB": "MEMORY-Toughram_XG_RGB_64gb.png",
    "RGB-DDR5-6000MTs-32GB-2x16GB": "MEMORY-Toughram_XG_RGB_32gb.png",
    "RGB-DDR5-6400MTs-32GB-2x16GB": "MEMORY-Toughram_XG_RGB_32gb.png",
    "1TB-NVMe-M2-SSD-Gen3": "STORAGE-1TB_GEN3.png",
    "1TB-NVMe-M2-SSD-Gen4": "STORAGE-1TB_GEN4.png",
    "2TB-NVMe-M2-SSD-Gen4": "STORAGE-2TB_GEN4.png",
    "1TB-Seagate-FireCuda-530-Gen4-NVMe-M2": "STORAGE_SeagateFireCuda_1TB_Gen4.png",
    "1TB-Seagate-FireCuda-530-Gen4-NVMe-M2-SSD": "STORAGE_SeagateFireCuda_1TB_Gen4.png",
    "1TB-Kingston-FURY-Renegade-Gen4-NVMe-M2-SSD": "STORAGE-Kingston_FURY_Renegade_1TB.png",
    "2TB-Kingston-FURY-Renegade-Gen4-NVMe-M2-SSD": "STORAGE-Kingston_FURY_Renegade_2TB.png",
    "1TB-WD-SN850X-Gen4-NVMe-M2": "STORAGE-WD_Black_SN850X_1TB.png",
    "2TB-WD-SN850X-Gen4-NVMe-M2": "STORAGE-WD_Black_SN850X_2TB.png",
    "Windows-10-Home": "OS-Windows10.png",
    "Windows-11-Home": "OS-Windows11.png",
    "Windows-11-Pro": "OS-Windows11.png",
    
    "Thermaltake-ARGENT-K5-RGB-Gaming-Keyboard-Cherry-MX-Blue": "KEYBOARD-Argent_K5_RGB_Cherry_MX_Blue.png",
    "Thermaltake-ARGENT-M5-RGB-Gaming-Mouse": "MOUSE-Argent_M5_RGB.png",
    "Thermaltake-TGM-V32CQ-Curve-Gaming-Monitor": "MONITOR-TGM-V32CQ_Curve_Gaming_Monitor.png",
    "Thermaltake-Triple-Racing-Monitor-Stand": "MONITOR-STAND-Triple_Racing_Monitor_Stand.png",
    "Logitech-G920-Driving-Force-Floor-Pedals-with-Racing-Wheel": "RACING-PEDALS-Logitech_G920_Driving_Force_Floor_Pedals.png",
    "Logitech-G920-Driving-Force-Floor-Pedals": "RACING-PEDALS-Logitech_G920_Driving_Force_Floor_Pedals.png",
    "No-Racing-Pedals": "Racing-Pedals_empty.png",
    "Logitech-G920-Driving-Force-Racing-Wheel-with-Floor-Pedals": "RACING-WHEEL-Logitech_G920_Driving_Force_Racing_Wheel.png",
    "Logitech-G920-Driving-Force-Racing-Wheel": "RACING-WHEEL-Logitech_G920_Driving_Force_Racing_Wheel.png",
    "No-Racing-Wheel": "Racing-Wheel_empty.png",
    "Reactor-i7TS": "GAMING-SYSTEM-Reactor_i7TS.png",
    
    "Cooling-Fan-Empty": "Cooling-Fan_empty.png",
    "Processor-Empty": "Processor_empty.png",
    "Motherboard-Empty": "Motherboard_empty.png",
    "Graphic-Card-Empty": "Graphic-Card_empty.png",
    "Power-Supply-Empty": "Power-Supply_empty.png",
    "Memory-Empty": "Memory_empty.png",
    "Primary-Storage-Empty": "Storage_empty.png",
    "Secondary-Storage-Empty": "Storage_empty.png",
    "Operating-System-Empty": "Operating-System_empty.png",
    "Gaming-System-Empty": "Gaming-System_empty.png",
    "Mouse-Empty": "Mouse_empty.png",
    "Keyboard-Empty": "Keyboard_empty.png",
    "Monitor-Empty": "Monitor_empty.png",
    "Monitor-Stand-Empty": "Monitor-Stand_empty.png",
    "Accessory-Tray-Empty": "Accessory-Tray_empty.png",
    "Floor-Mat-Empty": "Floor-Mat_empty.png",
    "Gear-Shifter-Empty": "Gear-Shifter_empty.png",
    "Racing-Pedals-Empty": "Racing-Pedals_empty.png",
    "Racing-Wheel-Empty": "Racing-Wheel_empty.png",
    "Coming-Soon": "coming-soon.png",
  }